import { ShareCompany, ShareUserDept, ShareUserDetail } from "../../model/share/ShareUserDetail";
import { CompanyInfo, DeptInfo } from "../../model/LoginUser";

/**
 *
 * @param {LoginUser} loginUser
 * @returns {ShareUserDetail|null}
 */
function transfer(loginUser) {
  if (loginUser == null) {
    return null;
  }

  let shareUser = new ShareUserDetail();

  let curCompany;
  if (loginUser.companyInfoList && loginUser.companyInfoList.length > 0) {
    curCompany = loginUser.companyInfoList.find(item => loginUser.currentCompanyId === item.companyId);
    shareUser.company = loginUser.companyInfoList.map(item => {
      let shareCompany = new ShareCompany();
      shareCompany.account = item.account;
      shareCompany.accountId = item.account;
      shareCompany.binCode = item.companyNameCn;
      // shareCompany.bussinessType = item.;
      // shareCompany.bussinessTypeCode = item.;
      shareCompany.companyId = item.companyId;
      shareCompany.default = 'N';
      shareCompany.name = item.companyNameCn;
      shareCompany.shortName = item.companyNameCn;
      // shareCompany.comCategory = item.;
      // shareCompany.groupType = item.;
      // shareCompany.groupTypeCode = item.;
      // shareCompany.infoId = item.;
      // shareCompany.logo = item.;
      // shareCompany.mark = item.;
      return shareCompany;
    });

    // 设置默认公司
    let defaultCompany = curCompany || {};
    let { companyId, companyNameCn = '' } = defaultCompany;
    shareUser.defaultCompany = {
      companyId,
      default: 'Y',
      name: companyNameCn,
      shortName: companyNameCn,
      binCode:companyNameCn=='集团（股份）总部'?'CNCEC':''
    };
  } else {
    curCompany = new CompanyInfo();
  }

  let curDept;
  if (curCompany.deptInfoList && curCompany.deptInfoList.length > 0) {
    curDept = curCompany.deptInfoList[0];
    shareUser.userDept = [];
    (loginUser.companyInfoList || []).forEach(company => {
      (company.deptInfoList || []).forEach(dept => {
        let shareUserDept = new ShareUserDept();
        shareUserDept.companyId = company.companyId;
        shareUserDept.companyName = company.companyNameCn;
        shareUserDept.defaultFlag = 'N';
        shareUserDept.deptId = dept.deptId;
        shareUserDept.deptName = dept.deptNameCn;
        // shareUserDept.duty = item.;
        // shareUserDept.dutyName = item.;
        shareUserDept.userName = loginUser.accountName;
        shareUser.userDept.push(shareUserDept);
      })
    })
  } else {
    curDept = new DeptInfo();
  }


  let shareAccount = shareUser.account;
  shareAccount.account = loginUser.account;
  shareAccount.accountId = loginUser.accountId;
  shareAccount.companyId = loginUser.currentCompanyId;
  shareAccount.infoId = loginUser.accountId;

  let shareUserInfo = shareUser.userInfo;
  shareUserInfo.account = loginUser.account;
  shareUserInfo.accountId = loginUser.accountId;
  shareUserInfo.companyId = curCompany.companyId;
  shareUserInfo.companyName = curCompany.companyNameCn;
  shareUserInfo.deptId = curDept.deptId;
  shareUserInfo.deptName = curDept.deptNameCn;
  shareUserInfo.ordered = loginUser.companySort;
  shareUserInfo.appOrgTreeId = loginUser.appOrgTreeId; // 新增：保存appOrgTreeId字段
  // shareUserInfo.duty = curDept.;
  // shareUserInfo.dutyName = curDept.;
  // shareUserInfo.idCard = loginUser.;
  shareUserInfo.infoId = loginUser.accountId;
  shareUserInfo.phone = loginUser.phone;
  shareUserInfo.email = loginUser.email;
  shareUserInfo.name = loginUser.accountName;
  // shareUserInfo.sex = loginUser.;
  // shareUserInfo.sexName = loginUser.;
  shareUserInfo.status = 1;
 
  return shareUser;
}

export default {
  transfer
}
